import React from 'react';
import { drapcodeIcon } from '../custom/icon-library';

const CancelButton = ({ icon = 'cancel', onClick, title, text }) => {
  return (
    <button type="button" className="btn btn-outline-secondary btn-md" onClick={onClick} title={title}>
      <i className={`wb ${drapcodeIcon(icon)}`}></i> {text}
    </button>
  );
};

export default CancelButton;
